import api from "../config/api/axiosConfig";

export const useIngredientApi = () => {
  const getIngredients = async () => {
    const response = await api.get("/Ingredient");
    return response;
  };

  const createIngredient = async (name: string) => {
    const response = await api.post("/Ingredient", { name });
    return response;
  };

  return {
    getIngredients,
    createIngredient,
  };
};
